import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function postInappropriateFlag (id) {

	try {

		const url = `${baseURI}/reviews/${id}/flag`;

		const response = await baseAPIRequest({
			url,
			params: { method: 'POST' }
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to flag inappropriate review: ${error.message}`);

		}

		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default postInappropriateFlag;
